import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { BookkeepersCompanyIncidenceMessageStatFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { getIncidencesUnreadMessagesCount } from 'modules/payroll_bundle/lib/Incidences/IncidenceFilters'

import MessagesStatBlock from './_MessagesStatBlock'

interface Props {
  stats: BookkeepersCompanyIncidenceMessageStatFragment[]
}

const StatsMessages = ({ stats }: Props) => {
  if (stats.length === 0) return <></>

  const { incidencesUnreadMessagesCount } = getIncidencesUnreadMessagesCount(stats).get()

  return (
    <Box width="s240">
      <MessagesStatBlock
        name={i18n.t('incidences.header.messages_stats_title')}
        value={incidencesUnreadMessagesCount}
      />
    </Box>
  )
}

export default StatsMessages
